export function DiscoveryIcon({ className = 'h-6 w-6', ...props }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <circle cx="12" cy="12" r="3.5" />
      <path d="M12 2v3M12 19v3M4.22 4.22l2.12 2.12M17.66 17.66l2.12 2.12M2 12h3M19 12h3M4.22 19.78l2.12-2.12M17.66 6.34l2.12-2.12" />
    </svg>
  );
}

export function DataIcon({ className = 'h-6 w-6', ...props }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <path d="M12 3l7 7-7 7-7-7 7-7z" />
      <path d="M12 3v14" />
      <path d="M8 12h8" />
    </svg>
  );
}

export function PlanIcon({ className = 'h-6 w-6', ...props }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <path d="M12 3v13" />
      <path d="M7 16h10l-5 5z" />
      <path d="M8 7l4-4 4 4" />
    </svg>
  );
}

export function LaunchIcon({ className = 'h-6 w-6', ...props }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <circle cx="12" cy="12" r="6" />
      <path d="M12 6v6l4 2" />
    </svg>
  );
}

export function CourseIcon({ className = 'h-6 w-6', ...props }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <path d="M12 2v8" />
      <path d="M8 10h8" />
      <path d="M5 14c2 4 12 4 14 0" />
    </svg>
  );
}

export function GraduationCap({ className = 'h-6 w-6', ...props }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <path d="M2.5 9.5L12 4l9.5 5.5L12 15z" />
      <path d="M6.5 11.5v3a5.5 5.5 0 0011 0v-3" />
      <path d="M19 13l2 1.2v2.8" />
    </svg>
  );
}

export function Users({ className = 'h-6 w-6', ...props }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <circle cx="8" cy="8" r="3" />
      <circle cx="17" cy="9.5" r="3" />
      <path d="M3 20v-1.2A5.8 5.8 0 018.8 13h0A5.2 5.2 0 0114 18.2V20" />
      <path d="M14 20v-1a5 5 0 018-4" />
    </svg>
  );
}

export function Briefcase({ className = 'h-6 w-6', ...props }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <rect x="3" y="7" width="18" height="12" rx="2" />
      <path d="M8 7V5a2 2 0 012-2h4a2 2 0 012 2v2" />
      <path d="M3 12h18" />
      <path d="M12 12v2" />
    </svg>
  );
}

export function Stethoscope({ className = 'h-6 w-6', ...props }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <path d="M4 4v5a4 4 0 108 0V4" />
      <path d="M12 9a4 4 0 108 0 4 4 0 10-8 0z" />
      <path d="M8 13.5V15a4 4 0 008 0v-1.5" />
      <path d="M20 9v2" />
    </svg>
  );
}

export function Flag({ className = 'h-6 w-6', ...props }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      <path d="M5 4v16" />
      <path d="M5 5h10l-2.5 4L15 13H5" />
    </svg>
  );
}
